import { render, staticRenderFns } from "./SessionItemGeo.vue?vue&type=template&id=d89c0190&"
import script from "./SessionItemGeo.vue?vue&type=script&lang=js&"
export * from "./SessionItemGeo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports